module.exports = __webpack_public_path__ + "static/media/Mulish-Regular.f7fa9bc8.woff";